<template>
  <!-- suspectedGroup    疑似群租房和非法商用-->
  <el-container class="suspectedGroup">
    <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="treeRef"
          :data="dataSource"
          node-key="id"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        >
        </el-tree>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="params"
        class="demo-form-inline"
      >
        <el-form-item label="房屋地址" prop="name">
          <el-input v-model="params.name" placeholder="房屋地址"></el-input>
        </el-form-item>
        <el-form-item label="预警时间">
          <h-date-timerange
            v-model:end="params.endDate"
            v-model:start="params.startDate"
          >
          </h-date-timerange>
        </el-form-item>
        <el-form-item>
          <h-button type="primary" @click="refreshTable(formRef)"
            >查询</h-button
          >
          <h-button @click="resetForm(formRef)">重置</h-button>
        </el-form-item>
      </el-form>
      <div class="table-box">
        <div class="centerBox">
          <div class="centerList" v-for="item in houselist" :key="item.wegId">
            <div class="topTime">
              预警时间 {{ item.warningTime || item.recodDate }}
            </div>
            <div class="centerItem">
              <div class="address">
                <div class="leftIcon">
                  <!-- <i class="iconfont icon-31sousuo"></i> -->
                  <!-- <img src="@/assets/images/moren.png" alt="" /> -->
                </div>
                <span class="borderColor">{{
                  item.houseInfo.houseAddress
                }}</span>
              </div>
              <el-row class="rowHeight">
                <!-- <el-col :span="6"> </el-col> -->
                <el-col :span="12">用水量</el-col>
                <el-col :span="2"
                  ><span class="redColor">{{
                    item.waterValue ? item.waterValue : "--"
                  }}</span></el-col
                >
                (吨)
              </el-row>
              <el-row class="rowHeight">
                <!-- <el-col :span="6"> </el-col> -->
                <el-col :span="12">用电量</el-col>
                <el-col :span="2"
                  ><span class="redColor">{{
                    item.electricityValue ? item.electricityValue : "--"
                  }}</span></el-col
                >
                (度)
              </el-row>
              <el-row class="rowHeight">
                <!-- <el-col :span="6"> </el-col> -->
                <el-col :span="12">用燃气量</el-col>
                <el-col :span="2"
                  ><span class="redColor">{{
                    item.gasValue ? item.gasValue : "--"
                  }}</span></el-col
                >
                (立方)
              </el-row>
              <el-row class="rowHeight" v-if="activeName == 'two'">
                <!-- <el-col :span="6"> </el-col> -->
                <el-col :span="12">{{ item.recodDate }}租户人数</el-col>
                <el-col :span="2"
                  ><span class="redColor">{{
                    item.totalPersonNum ? item.totalPersonNum : "--"
                  }}</span></el-col
                >
                (人)
              </el-row>
            </div>
            <!-- 租户人数：{{ item.totalPersonNum }} -->
          </div>
        </div>
        <div class="pagination">
          <!-- 分页 -->
          <el-pagination
            v-model:currentPage="params.page"
            v-model:page-size="params.limit"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
  </el-container>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
import { queryOrganList } from "@/api/system";
import { getMenutree } from "@/api/system/region.js";
import moment from "moment";
import { formatDateHMS } from "@/utils/index.js";
import {
  houseWeg,
  listWarning,
} from "@/api/publicSecurityResearch/suspectedGroup.js";
import util from "@util/js";
// import _ from "lodash";
export default defineComponent({
  name: "suspectedGroup",
  components: {},
  props: {
    activeName: {
      type: String,
      default: "two", //two：疑似群租房  one：疑似非法商用
    },
  },
  setup(props) {
    const state = reactive({
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: [],
      userFormData: {},
      tableParams: {
        name: "",
        date: "",
      },
      totalCount: 0,
      datearr: [],
      houselist: [],
      params: {
        name: "",
        page: 1,
        limit: 20,
        houseAddress: null,
        regionld: 0,
        startDate: formatDateHMS(
          moment(new Date().getTime() - 3600 * 1000 * 24 * 30)
        ), //开始日期
        endDate: formatDateHMS(new Date()), //结束日期
        threshold: 1,
      },
    });
    const refData = toRefs(state);
    const formRef = ref(null);
    // // 获取水电煤气列表
    // const gethouselist = async () => {
    //   const res = await houseWeg(state.params);
    //   state.houselist = res.page.list;
    //   console.log(res.page.list, "22222222222222222");
    // };
    // 获取群租列表
    const listWarninglist = async () => {
      if (props.activeName == "two") {
        const res = await listWarning(state.params);
        state.houselist = res.page.list;
        state.totalCount = res.page.totalCount;
      } else if (props.activeName == "one") {
        const res = await houseWeg(state.params);
        state.houselist = res.page.list;
        state.totalCount = res.page.totalCount;
      }
    };
    // 分页
    const handleSizeChange = (item) => {
      data.limit = item;
      listWarninglist();
    };
    const handleCurrentChange = (item) => {
      data.page = item;
      listWarninglist();
    };
    // gethouselist();
    listWarninglist();
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      state.params.regionId = item.deptId;
      state.userFormData.parentId = item.deptId;
      nextTick(() => {
        refreshTable();
      });
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      // const result = await queryOrganList();
      const result = await getMenutree();
      // const options = { pid: "parentId", id: "deptId", rootPid: result.top };
      // const treeData = util.arrayToTree(result.deptList, options);
      state.dataSource = [result.data];
      if (state.dataSource[0]) {
        currentChange(state.dataSource[0]);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.deptId;
          // treeRef.value.setCurrentKey(state.currentNode.deptId);
        });
      }
    };
    // 清空表单
    const resetForm = (formEl) => {
      console.log(formEl);
      if (!formEl) return;
      formEl.resetFields();
    };
    // 提交
    const refreshTable = () => {
      listWarninglist();
    };

    queryOrganTreAsync();
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    return {
      refreshTable,
      resetForm,
      listWarninglist,
      handleSizeChange,
      handleCurrentChange,
      ...refData,
      filterNode,
      currentChange,
      hzTableSelect,
      formRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.suspectedGroup {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      .table-role {
        color: #294a7c;
        cursor: pointer;

        text-align: center;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
  .centerBox {
    overflow: auto;
    width: 100%;
    height: 95%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    .centerList {
      width: 280px;
      // height: 170px;
      border-radius: 4px;
      margin: 8px;
      padding: 10px;
      color: #fff;
      background-color: #a5b8d6;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .centerItem {
        .address {
          display: flex;
          margin: 10px 0;
        }
        .leftIcon {
          margin-right: 10px;
          img {
            width: 70px;
            height: 100px;
          }
          .iconfont {
            font-size: 40px;
          }
        }
        .rowHeight {
          line-height: 24px;
        }
      }
    }
  }
  .redColor {
    color: #f00;
  }
  .borderColor {
    color: #5584ff;
    border-bottom: 1px solid #5584ff;
    cursor: pointer;
  }
}
</style>
